<div class="container-fluid">
    <div class="row">

      <div class="card shadow-sm">
        <div class="card-header">
          <h3 class="card-title">{{ userId ? 'Update User' : 'Create User' }} </h3>
        </div>
        <div class="card-body">
          <users-form
            [user]="user"
            (onSavedData)="onUsersFormSavedData($event)"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <profile-company class="p-0" [user]="user"/>
    </div>
    <div class="row">
      <two-factor-setup-card [user]="user" (mfaChanged)="loadData(userId)" />
    </div>
  </div>
  